import { Paperclip } from 'lucide-react'
import type { SchemaField } from '../../../../types/schede'
import FieldWrapper from './FieldWrapper'

interface FileFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function FileField({ field, value, onChange, readOnly, error }: FileFieldProps) {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      onChange(file.name)
    }
  }

  return (
    <FieldWrapper field={field} error={error}>
      {value && (
        <div
          className="flex items-center gap-2 px-2 py-1.5 mb-1 border rounded text-xs"
          style={{
            borderColor: 'var(--color-border)',
            backgroundColor: 'var(--color-bg-tertiary, #f5f5f5)',
            color: 'var(--color-text-secondary)',
          }}
        >
          <Paperclip className="w-3.5 h-3.5" />
          <span>{String(value)}</span>
        </div>
      )}
      {!readOnly && (
        <input
          type="file"
          onChange={handleFileChange}
          className="w-full text-xs file:mr-2 file:py-1 file:px-2 file:rounded file:border file:text-xs file:cursor-pointer"
          style={{
            color: 'var(--color-text-primary)',
          }}
        />
      )}
      {readOnly && !value && (
        <div
          className="text-xs px-2 py-3 border rounded text-center"
          style={{
            borderColor: 'var(--color-border)',
            color: 'var(--color-text-tertiary)',
          }}
        >
          Nessun file
        </div>
      )}
    </FieldWrapper>
  )
}
